/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoSpecialBoxLogListRequest model module.
 * @module model/LogControllerDtoSpecialBoxLogListRequest
 * @version 1.0
 */
class LogControllerDtoSpecialBoxLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoSpecialBoxLogListRequest</code>.
     * @alias module:model/LogControllerDtoSpecialBoxLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoSpecialBoxLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoSpecialBoxLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoSpecialBoxLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoSpecialBoxLogListRequest} The populated <code>LogControllerDtoSpecialBoxLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoSpecialBoxLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('account')) {
                obj['account'] = ApiClient.convertToType(data['account'], 'String');
            }
            if (data.hasOwnProperty('specialBoxNo')) {
                obj['specialBoxNo'] = ApiClient.convertToType(data['specialBoxNo'], 'Number');
            }
            if (data.hasOwnProperty('playedGameSessionNo')) {
                obj['playedGameSessionNo'] = ApiClient.convertToType(data['playedGameSessionNo'], 'Number');
            }
            if (data.hasOwnProperty('openTransactionNo')) {
                obj['openTransactionNo'] = ApiClient.convertToType(data['openTransactionNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoSpecialBoxLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoSpecialBoxLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoSpecialBoxLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['account'] && !(typeof data['account'] === 'string' || data['account'] instanceof String)) {
            throw new Error("Expected the field `account` to be a primitive type in the JSON string but got " + data['account']);
        }

        return true;
    }


}

LogControllerDtoSpecialBoxLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} account
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['account'] = undefined;

/**
 * @member {Number} specialBoxNo
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['specialBoxNo'] = undefined;

/**
 * @member {Number} playedGameSessionNo
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['playedGameSessionNo'] = undefined;

/**
 * @member {Number} openTransactionNo
 */
LogControllerDtoSpecialBoxLogListRequest.prototype['openTransactionNo'] = undefined;






export default LogControllerDtoSpecialBoxLogListRequest;

